module.exports = __webpack_public_path__ + "static/media/logo.84a9a862.svg";